import { writable } from "svelte/store";
import { onDestroy } from "svelte";

function defaultCalc(width) {
  // if (width > 1279) {
  //   return "xl";
  // }
  if (width > 1024) {
    return "desktop";
  }else{
    return "mobile";
  }
  // if (width > 767) {
  //   return "md";
  // }
  // return "sm";
}

export default function breakpoint(calcBreakpoint = defaultCalc) {
  if (typeof window === "undefined") return writable("sm");

  const store = writable(calcBreakpoint(window.innerWidth));

  const onResize = ({ target }) => store.set(calcBreakpoint(target.innerWidth));

  window.addEventListener("resize", onResize);
  onDestroy(() => window.removeEventListener("resize", onResize));

  return {
    subscribe: store.subscribe
  };
}